import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatRipple } from "@angular/material/core";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: "app-icon-toggle",
  templateUrl: "./icon-toggle.component.html",
  styleUrls: ["./icon-toggle.component.less"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatRipple, MatTooltip, MatIcon],
})
export class IconToggleComponent {
  @Input("toggleFormControl")
  public toggleFormControl!: FormControl;

  @Input("falseIconName")
  public falseIconName!: string;

  @Input("falseText")
  public falseText!: string;

  @Input("falseTooltip")
  public falseTooltip?: string;

  @Input("falseAriaLabel")
  public falseAriaLabel!: string;

  @Input("trueIconName")
  public trueIconName!: string;

  @Input("trueText")
  public trueText!: string;

  @Input("trueTooltip")
  public trueTooltip?: string;

  @Input("trueAriaLabel")
  public trueAriaLabel!: string;

  public toggleValue() {
    this.toggleFormControl.setValue(!this.toggleFormControl.value);
  }
}
